import { DataSource, mapDataSource } from '~/Api/DataSource';
import ApiClient from '~/ApiClient';

export interface Result {
	items: DataSource[];
}

export default async function findDataSources(client: ApiClient): Promise<Result> {
	const request = await client.fetch('analytics/datasources');
	const response = await request.json();
	return { items: response.items.map(mapDataSource) };
}
